import { Attributes } from "../../shared/types/attributes.type";

export class BatchInventoryEntity {
  private constructor(
    public readonly occupations: [],
    public readonly accommodations: [],
    public readonly mealPlans: [],
    public readonly conditions: []
  ) {}

  static of(props: Attributes<BatchInventoryEntity>): BatchInventoryEntity {
    return new BatchInventoryEntity(
      props.occupations,
      props.accommodations,
      props.mealPlans,
      props.conditions
    );
  }

  static empty(): BatchInventoryEntity {
    return new BatchInventoryEntity([], [], [], []);
  }
}
